"use client"
import React, { useState, useEffect } from "react";
import { useSearchParams } from "next/navigation";
import { useTenant } from "@/lib/providers/TenantProvider";

import CommunityCalendarView from "@/components/events/CommunityCalendarView";

const EmbeddedCalendarWidget = props => {
  const { profile, community } = useTenant();
  const searchParams = useSearchParams();
  const [loaded, setLoaded] = useState(false);
  const key = searchParams.get("key");
  const showMap = searchParams.get("showMap") === "true";

  useEffect(() => {
    if (key && !loaded) {
      setLoaded(true);
    }
  }, [key, profile, community, loaded]);

  if (loaded && community) {
    return (
      <CommunityCalendarView
        external={true}
        name={profile.resourceName}
        community={community}
        showMap={showMap}
      />
    );
  } else if (!loaded) {
    return <></>;
  }
};

export default EmbeddedCalendarWidget;
